import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from "../../store/reducers/modal";

const SearchModal = () => {

    const isOpen = useSelector((state) => state.modals.searchModal);
    const dispatch = useDispatch();

    if (!isOpen) return null;

    const onBtnClose = () => {
        dispatch(closeModal("searchModal"))
    }

    return (
        <>{/* <!-- Search --> */}
            <div className="w3-ch-sideBar w3-bar-block w3-card-2 w3-animate-right" style={{ display: isOpen ? 'block' : 'none', right: 0 }} id="Search">
                <div className="rightMenu-scroll">
                    <div className="d-flex align-items-center justify-content-between slide-head py-3 px-3">
                        <h4 className="cart_heading fs-md ft-medium mb-0">Search Products</h4>
                        <button onClick={onBtnClose} className="close_slide"><i className="ti-close"></i></button>
                    </div>

                    <div className="cart_action px-3 py-4">
                        <form className="form m-0 p-0">
                            <div className="form-group">
                                <input type="text" className="form-control" placeholder="Product Keyword.." />
                            </div>

                            <div className="form-group">
                                <select className="custom-select">
                                    <option value="1" selected="">Choose Category</option>
                                    <option value="2">Men's Store</option>
                                    <option value="3">Women's Store</option>
                                    <option value="4">Kid's Fashion</option>
                                    <option value="5">Inner Wear</option>
                                </select>
                            </div>

                            <div className="form-group mb-0">
                                <button type="button" className="btn d-block full-width btn-dark">Search Product</button>
                            </div>
                        </form>
                    </div>

                    <div className="d-flex align-items-center justify-content-center br-top br-bottom py-2 px-3">
                        <h4 className="cart_heading fs-md mb-0">Hot Categories</h4>
                    </div>

                    <div className="cart_action px-3 py-3">
                        <div className="row">
                            <div className="col-xl-4 col-lg-4 col-md-4 col-4 mb-3">
                                <div className="cats_side_wrap text-center">
                                    <div className="sl_cat_01"><div className="d-inline-flex align-items-center justify-content-center p-3 circle mb-2 gray"><a href="#search-tshirt" className="d-block"><img src="assets/img/tshirt.png" className="img-fluid" width="40" alt="T-Shirts" /></a></div></div>
                                    <div className="sl_cat_02"><h6 className="m-0 ft-medium fs-sm"><a href="#search-tshirt">T-Shirts</a></h6></div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-4 mb-3">
                                <div className="cats_side_wrap text-center">
                                    <div className="sl_cat_01"><div className="d-inline-flex align-items-center justify-content-center p-3 circle mb-2 gray"><a href="#search-pant" className="d-block"><img src="assets/img/pant.png" className="img-fluid" width="40" alt="Pants" /></a></div></div>
                                    <div className="sl_cat_02"><h6 className="m-0 ft-medium fs-sm"><a href="#search-pant">Pants</a></h6></div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-4 mb-3">
                                <div className="cats_side_wrap text-center">
                                    <div className="sl_cat_01"><div className="d-inline-flex align-items-center justify-content-center p-3 circle mb-2 gray"><a href="#search-women" className="d-block"><img src="assets/img/fashion.png" className="img-fluid" width="40" alt="Women" /></a></div></div>
                                    <div className="sl_cat_02"><h6 className="m-0 ft-medium fs-sm"><a href="#search-women">Women's</a></h6></div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-4 mb-3">
                                <div className="cats_side_wrap text-center">
                                    <div className="sl_cat_01"><div className="d-inline-flex align-items-center justify-content-center p-3 circle mb-2 gray"><a href="#search-shoes" className="d-block"><img src="assets/img/sneakers.png" className="img-fluid" width="40" alt="Shoes" /></a></div></div>
                                    <div className="sl_cat_02"><h6 className="m-0 ft-medium fs-sm"><a href="#search-shoes">Shoes</a></h6></div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-4 mb-3">
                                <div className="cats_side_wrap text-center">
                                    <div className="sl_cat_01"><div className="d-inline-flex align-items-center justify-content-center p-3 circle mb-2 gray"><a href="#search-television" className="d-block"><img src="assets/img/television.png" className="img-fluid" width="40" alt="Television" /></a></div></div>
                                    <div className="sl_cat_02"><h6 className="m-0 ft-medium fs-sm"><a href="#search-television">Television</a></h6></div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-4 mb-3">
                                <div className="cats_side_wrap text-center">
                                    <div className="sl_cat_01"><div className="d-inline-flex align-items-center justify-content-center p-3 circle mb-2 gray"><a href="#search-accessories" className="d-block"><img src="assets/img/accessories.png" className="img-fluid" width="40" alt="Accessories" /></a></div></div>
                                    <div className="sl_cat_02"><h6 className="m-0 ft-medium fs-sm"><a href="#search-accessories">Accessories</a></h6></div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default SearchModal